import { Routes } from '@angular/router';

export const PARENTSAMPLESUPPLIER_ROUTES: Routes = [
  {
    path: 'channels/parent-sample-suppliers/view-edit/:parentSampleSupplierId',
    loadComponent: () =>
      import('./parent-sample-supplier-view-edit/parent-sample-supplier-view-edit.component').then(
        (com) => com.ParentSampleSupplierViewEditComponent
      ),
    title: 'View/Edit Parent Sample Supplier',
  },
  {
    path: 'channels/parent-sample-suppliers/add',
    loadComponent: () =>
      import('./parent-sample-supplier-add/parent-sample-supplier-add.component').then(
        (com) => com.ParentSampleSupplierAddComponent
      ),
    title: 'Add Parent Sample Supplier',
  },
];
